module.exports = __webpack_public_path__ + "sem_kriteriev_otsenki.d7a5b89d15158a8f4ce09eea7b0ec11b.jpg";